import ReactMarkdown from "react-markdown";
import remarkMath from "remark-math";
import remarkGfm from "remark-gfm";
import rehypeKatex from "rehype-katex";

// Renders assistant text as Markdown with LaTeX math ($...$ / $$...$$) and GFM.
export function MarkdownMessage({ children, className = "" }) {
  return (
    <div className={`md-body ${className}`} data-testid="markdown-body">
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkMath]}
        rehypePlugins={[rehypeKatex]}
        components={{
          a: ({ node, ...props }) => (
            <a {...props} target="_blank" rel="noreferrer" className="underline decoration-dotted" />
          ),
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
